<template>
  <div class="d-ib">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="setDialog(true)"
    >
      Filters
    </el-button>
    <el-dialog
      title="Filters"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialog(false)"
    >
      <el-input type="text" v-model="user" placeholder="User" clearable />
      <el-input
        type="text"
        v-model="track"
        placeholder="Track"
        clearable
        class="mt10"
      />
      <el-input
        type="text"
        v-model="license"
        placeholder="License"
        clearable
        class="mt10"
      />
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      user: '',
      track: '',
      license: ''
    }
  },
  computed: {
    ...mapState('youtubeLicensing', ['dialog'])
  },
  methods: {
    ...mapMutations('youtubeLicensing', ['setDialog', 'setFilter', 'setPage']),
    ...mapActions('youtubeLicensing', ['readLicensing']),

    filter() {
      this.setFilter({
        user: this.user,
        track: this.track,
        license: this.license
      })
      this.setPage(1)
      this.readLicensing()
      this.setDialog(false)
    },

    clear() {
      this.setFilter({})
      this.readLicensing()
      this.user = ''
      this.track = ''
      this.license = ''
      this.setDialog(false)
    }
  }
}
</script>
